export function endMeasurementAction() {
  const { t } = useI18n();
  const viewerDistanceMeasurementsStore = useViewerDistanceMeasurementsStore();

  return {
    getTitle: () => {
      return 'End Editing';
    },
    getEnabled: function () {
      return viewerDistanceMeasurementsStore.measurementEditEnabled;
    },
    doAction: function () {
      const editControl = viewerDistanceMeasurementsStore.getEditMouseControl();
      const editTouchControl = viewerDistanceMeasurementsStore.getEditTouchControl();

      if (!editControl || !editTouchControl) return;

      if (editControl) editControl.deactivate();
      if (editTouchControl) editTouchControl.deactivate();

      viewerDistanceMeasurementsStore.measurementEditEnabled = false;
    },
  };
}
